<template>
<base-dialog-modal :title="'Verwijder ' + title "
                   ref="deleteModal">
	<div slot="modal-body">
		<div class="row">
			<div class="col">
				Weet u zeker dat u {{ deleteName }} wilt verwijderen?
			</div>
		</div>
	</div>
	<div slot="modal-footer">
		<div class="row">
			<div class="col">
				<b-button class="mt-3"
				          type="button"
				          variant="outline-primary"
				          block
				          @click="onCancel">

					{{ cancelButtonText }}

				</b-button>
			</div>
			<div class="col">
				<b-button class="mt-3"
				          type="button"
				          v-bind:disabled="isDeleting"
				          block
				          variant="outline-danger"
				          @click="onConfirm">

					<loader-spinner :text="confirmButtonText"
					                :show-spinner="isDeleting"></loader-spinner>

				</b-button>
			</div>
		</div>
	</div>
</base-dialog-modal>
</template>
<script>
import { isNil } from 'lodash';
import BaseDialogModal from '@/components/elements/Base/BaseDialogModal';
import LoaderSpinner from '@/components/elements/LoaderSpinner';

export default {
	components: {
		BaseDialogModal,
		LoaderSpinner
	},
	name: 'delete-dialog-modal',
	data: () => ({}),
	props: {
		cancelButtonText: {
			type: String,
			default: 'Annuleren'
		},
		confirmButtonText: {
			type: String,
			default: 'Verwijderen'
		},
		title: {
			type: String,
			default: ''
		},
		deleteName: {
			type: String,
			default: ''
		},
		isDeleting: {
			type: Boolean,
			default: false
		},
		item: {
			default: null
		}
	},
	methods: {
		/**
		 * Hide the modal
		 */
		hide() {
			this.$refs.deleteModal.hide();
		},

		/**
		 * Show the modal
		 */
		show() {
			this.$refs.deleteModal.show();
		},

		/**
		 * On cancel emit cancel event and hide modal
		 */
		onCancel() {
			this.$emit('cancel');
			this.hide();
		},

		/**
		 * On confirm emit confirm event with optional the item
		 */
		onConfirm() {
			if (this.isDeleting == false) {
				if (isNil(this.item)) {
					this.$emit('confirm');
				} else {
					this.$emit('confirm', this.item);
				}
			}
		}
	}
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// DeleteDialogModal.vue?3ce386e5